import React, { Fragment, useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import AppLayout from "./components/layouts/AppLayout";
import Cosmetic from "./components/pages/Cosmetic";
import Home from "./components/pages/Home";
import NoPage from "./components/utils/NoPage";
import CosmeticDetail from "./components/pages/Cosmetic/detail/CosmeticDetail";

import "./css/App.css";
import "./css/Layout.css";
import "./css/Nav.css";
import "./css/Cosmetic.css";
import "./css/Home.css";
import "./css/Profile.css";

import ReactGA from "react-ga4";
import Profile from "./components/pages/Profile";
import { Helmet } from "react-helmet";

ReactGA.initialize([
  {
    trackingId: "G-3VGRVFWHW6",
    gaOptions: { siteSpeedSampleRate: 100 },
    gtagOptions: {},
  },
]);

function useProfileParamWatcher() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const prevPlayer = useRef(searchParams.get("player"));

  useEffect(() => {
    const currentPlayer = searchParams.get("player");

    prevPlayer.current = currentPlayer;
  }, [location, searchParams]);
}

export default function App() {
  const [ready, setReady] = React.useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setReady(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      document.querySelector(".notice")?.remove();
    }, 6000);
  }, []);

  return (
    <Router>
      <ProfileReloadHandler />
      <div id="App">
        <Helmet>
          <meta charset="utf-8" />
          <link rel="icon" href="https://app.zeqa.net/favicon/favicon.ico" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="theme-color" content="#FCD35A" />
          <title>Zeqa's Web Application</title>
          <meta name="title" content="Zeqa's Web Application" />
          <meta name="description" content="Zeqa Network's Official Web App" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://app.zeqa.net/" />
          <meta property="og:title" content="Zeqa's Web Application" />
          <meta
            property="og:description"
            content="Zeqa Network's Official Web App"
          />
          <meta
            property="og:image"
            content="https://app.zeqa.net/image/Zeqa.webp"
          />
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content="https://app.zeqa.net/" />
          <meta property="twitter:title" content="Zeqa Web App" />
          <meta
            property="twitter:description"
            content="Zeqa Network's Official Web App"
          />
          <meta
            property="twitter:image"
            content="https://app.zeqa.net/image/Zeqa.webp"
          />{" "}
        </Helmet>
        <AppLayout>
          <Fragment>
            {ready ? (
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route path="/cosmetic">
                  <Route exact path="/cosmetic/:type" element={<Cosmetic />} />
                  <Route
                    path="/cosmetic/:type/:id"
                    element={<CosmeticDetail />}
                  />
                </Route>
                <Route path="/profile" element={<Profile />} />
                <Route exact path="*" element={<NoPage />} />
              </Routes>
            ) : null}
          </Fragment>
        </AppLayout>
      </div>
    </Router>
  );
}

function ProfileReloadHandler() {
  useProfileParamWatcher();
  return null;
}
